<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol" aria-hidden="true">
    <path
      fill="currentColor"
      d="M5.7.4c.3-.2.6-.4 1-.4s.8.2 1.1.4l10.5 10.5c.3.3.4.7.4 1.1 0 .4-.2.8-.4 1.1L7.8 23.6c-.3.3-.7.4-1 .4-.4 0-.8-.2-1-.4-.3-.3-.4-.7-.4-1 0-.4.1-.8.4-1.1l9.4-9.4-9.5-9.5c-.3-.3-.5-.7-.5-1.1s.2-.8.5-1.1z"
    />
  </svg>
</template>
